import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-20 flex-col items-center justify-center py-20" }
const _hoisted_2 = { class: "mb-5 text-sm text-gray-400 dark:text-gray-500" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Is Er Nog Gas.nl", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "font-semibold hover:underline",
  target: "_blank",
  href: "https://github.com/nickthesing"
}, "Nick", -1)
const _hoisted_5 = { class: "text-sm text-gray-400 dark:text-gray-500" }


export default /*#__PURE__*/_defineComponent({
  __name: 'PageFooter',
  setup(__props) {

const year = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(" Copyright © " + _toDisplayString(_unref(year)) + " - ", 1),
      _hoisted_3,
      _createTextVNode(" - All rights reserved | Created by "),
      _hoisted_4
    ]),
    _createElementVNode("p", _hoisted_5, [
      _createVNode(_component_router_link, { to: "/disclaimer" }, {
        default: _withCtx(() => [
          _createTextVNode("Disclaimer")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "ml-10",
        to: "/woordenlijst"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Woordenlijst")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})